import type { Behavior, PopulateSource } from '@capture/shared';

interface Props {
  behavior: Extract<Behavior, { kind: 'populate' }>;
  onChange: (b: Behavior) => void;
  fieldNames: string[];
  advanced: boolean;
}

export function PopulateBody({ behavior, onChange }: Props) {
  const src = behavior.source;
  function setSource(next: PopulateSource) { onChange({ ...behavior, source: next }); }

  return (
    <div className="populate-body">
      <label>
        Source type
        <select value={src.type} onChange={(e) => {
          const t = e.target.value as PopulateSource['type'];
          if (t === 'literal') setSource({ type: 'literal', value: '' });
          else if (t === 'ocr-zone') setSource({ type: 'ocr-zone', zoneId: '' });
          else if (t === 'header-xpath') setSource({ type: 'header-xpath', xpath: '' });
          else setSource({ type: 'sequence', name: '' });
        }}>
          <option value="literal">Literal</option>
          <option value="ocr-zone">OCR zone</option>
          <option value="header-xpath">Header XPath</option>
          <option value="sequence">Sequence</option>
        </select>
      </label>

      {src.type === 'literal' && (
        <label>Value <input value={src.value} onChange={(e) => setSource({ type: 'literal', value: e.target.value })} /></label>
      )}
      {src.type === 'ocr-zone' && (
        <label>Zone id <input value={src.zoneId} onChange={(e) => setSource({ type: 'ocr-zone', zoneId: e.target.value })} /></label>
      )}
      {src.type === 'header-xpath' && (
        <label>XPath <input value={src.xpath} onChange={(e) => setSource({ type: 'header-xpath', xpath: e.target.value })} /></label>
      )}
      {src.type === 'sequence' && (
        <label>Sequence name <input value={src.name} onChange={(e) => setSource({ type: 'sequence', name: e.target.value })} /></label>
      )}
    </div>
  );
}
